import builder from '../builder';
import Close from '../../streamline-icons/light/close.svg';

export default builder('IconCloseLight', Close);
